// @flow
export { default } from './FakeLink';



// WEBPACK FOOTER //
// ./src/components/common/FakeLink/index.js